class ProductSizes extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.handleTrigger = this.handleTrigger.bind(this)

    this.listeners.add(document, 'click', this.handleTrigger)
  }

  async handleTrigger (event) {
    const trigger = event.target.closest(
      '[data-product-sizes-external-el="trigger"]',
    )

    if (!trigger) return

    await window.BAO.sectionRenderer
      .fetchSingle('product-sizes', trigger.dataset.productUrl)
      .then((res) => {
        const newDOM = window.BAO.sectionRenderer.convertToDOM(res)

        const bodyContent = newDOM.querySelector('.drw-Sizes')

        this.els.body.element.innerHTML = bodyContent.outerHTML

        window.drawers.activeDrawerKey = 'product-sizes'
      })
      .catch(() => {
        window.drawers.activeDrawerKey = ''
      })
  }
}

if (!customElements.get('product-sizes')) {
  customElements.define('product-sizes', ProductSizes)
}
